import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AdminRoutes from "Routes/Components/Admin";

import { HTTPErrorCallback } from "Helpers/Error";
import { formatCurrency } from "Helpers/Format";

import UseServices from "Hooks/UseServices";

import ContainerWithTitle from "Components/Admin/ContainerWithTitle";
import PageWrapper from "Components/Admin/PageWrapper";
import Section from "Components/Admin/Section";

import Info from "./Components/Info";
import InfosRow from "./Components/InfosRow";
import * as S from "./styles";

const Dashboard = () => {
  const { api } = UseServices();
  const navigate = useNavigate();

  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    getDashboard(1);
  }, []);

  const getDashboard = () => {
    api
      .post("/projects/admin/dashboard")
      .then((response) => {
        setDashboard(response.data);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const formatNumber = (number) => {
    const numberFormat = new Intl.NumberFormat("pt-BR");
    const result = numberFormat.format(number);
    return isNaN(result) ? "N/A" : result;
  };

  return (
    <PageWrapper>
      <Section>
        <ContainerWithTitle icon="GridAlt" title="Dashboard">
          <S.Row>
            <InfosRow icon="News" label="Projetos">
              <Info
                number={formatNumber(dashboard?.all_projects)}
                labelComponent="Projetos Cadastrados"
                onClick={() => navigate(AdminRoutes.ListProjects.path)}
              />

              <Info
                number={formatNumber(dashboard?.sponsored_projects)}
                labelComponent="Projetos Patrocinados"
                onClick={() =>
                  navigate(AdminRoutes.ListProjects.path, {
                    state: { sponsored: true },
                  })
                }
              />
            </InfosRow>

            <InfosRow icon="Package" label="Patrocínio">
              <Info
                number={formatNumber(dashboard?.sponsors)}
                labelComponent="Patrocinadores"
                onClick={() => navigate(AdminRoutes.ListSponsors.path)}
              />

              <Info
                number={formatCurrency(dashboard?.total_value)}
                labelComponent="Valor Captado"
              />
            </InfosRow>

            <InfosRow icon="User" label="Alcance">
              <Info
                number={formatNumber(dashboard?.impacted_people)}
                labelComponent="Pessoas Impactadas"
              />

              <Info
                number={formatNumber(dashboard?.covered_territories)}
                labelComponent="Territórios Cobertos"
              />
            </InfosRow>
          </S.Row>
        </ContainerWithTitle>
      </Section>
    </PageWrapper>
  );
};

export default Dashboard;
